package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.List
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.PortalModulo

/**
 * Hub unificado: Parte 1 = Relatório Fotográfico-Alojamento;
 * Parte 2 = Checklist Alojamento. Salvar exige ambas as partes.
 */
@Composable
fun SharedRelatorioAlojamentoScreen(controller: AppController) {
    var parte by remember { mutableStateOf(0) }

    PortalModulo(
        titulo = "Relatório Alojamento",
        itens = listOf(
            PortalMenuItem("foto", "Parte 1 — Fotográfico", Icons.Filled.Edit),
            PortalMenuItem("check", "Parte 2 — Checklist", Icons.Filled.List)
        ),
        selecionado = if (parte == 0) "foto" else "check",
        onSelect = {
            if (it == "check") {
                controller.syncCamposCompartilhadosAlojamento()
                parte = 1
            } else {
                parte = 0
            }
        },
        rolavel = false
    ) {
        Box(Modifier.weight(1f).fillMaxWidth().fillMaxSize()) {
            when (parte) {
                0 -> SharedRelatorioFotoScreen(
                    controller = controller,
                    modoCombinado = true,
                    onAvancarParte2 = {
                        controller.syncCamposCompartilhadosAlojamento()
                        parte = 1
                    }
                )
                else -> SharedChecklistAlojamentoScreen(
                    controller = controller,
                    modoCombinado = true
                )
            }
        }
    }
}
